import {
  enumUnionJsonFormat,
  JsonFormat,
  objectJsonFormat,
  stringJsonFormat,
  typedStringJsonFormat,
} from "@redotech/json/format";

export const ProcessingActionType = { AssignGrade: "assign_grade" } as const;
export type ProcessingActionType =
  (typeof ProcessingActionType)[keyof typeof ProcessingActionType];

export interface AssignGrade {
  type: typeof ProcessingActionType.AssignGrade;
  grade: string;
}

export const assignGradeJsonFormat: JsonFormat<AssignGrade> = objectJsonFormat(
  {
    type: typedStringJsonFormat(ProcessingActionType.AssignGrade),
    grade: stringJsonFormat,
  },
  {},
);

export type ProcessingAction = AssignGrade;

export const processingActionJsonFormat: JsonFormat<ProcessingAction> =
  enumUnionJsonFormat("type", "type", {
    [ProcessingActionType.AssignGrade]: assignGradeJsonFormat,
  });
